module.exports = __webpack_public_path__ + "images/emoji/rowboat.45240c5636880392ee09.png";